type TextFieldProps = {
	id: string;
	label: string;
	placeholder: string;
	value: string;
	onInput: (value: string) => void;
	type?: "text" | "email" | "tel";
	labelClassName: string;
	inputClassName: string;
	required?: boolean;
};

export function TextField({
	id,
	label,
	placeholder,
	value,
	onInput,
	type = "text",
	labelClassName,
	inputClassName,
	required = true,
}: TextFieldProps) {
	return (
		<div>
			<label htmlFor={id} className={labelClassName}>
				{label}
			</label>
			<input
				type={type}
				id={id}
				placeholder={placeholder}
				value={value}
				onInput={(e) => onInput((e.target as HTMLInputElement).value)}
				className={inputClassName}
				required={required}
			/>
		</div>
	);
}
